import { render, staticRenderFns } from "./drugStatistics.vue?vue&type=template&id=4626a1f2&scoped=true"
import script from "./drugStatistics.vue?vue&type=script&lang=js"
export * from "./drugStatistics.vue?vue&type=script&lang=js"
import style0 from "./drugStatistics.vue?vue&type=style&index=0&id=4626a1f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626a1f2",
  null
  
)

export default component.exports